import { isTabURL } from '@/constants/urls';
import workspacesApi from './api';
import workspaceLayout from './layout';
import workspaceFrames from './frames';

export default [
  workspacesApi(),
  workspaceLayout(),
  ...(isTabURL() ? [workspaceFrames()] : []),
];
